import { render } from "./CardContactPerson.vue?vue&type=template&id=bd568e66&ts=true"
import script from "./CardContactPerson.vue?vue&type=script&lang=ts"
export * from "./CardContactPerson.vue?vue&type=script&lang=ts"

import "./CardContactPerson.vue?vue&type=style&index=0&id=bd568e66&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__